module.exports = __webpack_public_path__ + "img/icon-white-52.2e01b364.svg";